<template>
  <a-modal :title="title" :visible="showTubeView" :width="900" destroyOnClose @ok="handleOk" @cancel="closeTubeView">
    <a-modal
      title="地图"
      style="top: 20px"
      :width="800"
      v-model="mapVisible"
      @ok="mapVisible = false"
      @cancel="mapVisible = false"
    >
      <lonlat-map @handleMapOk="handleMapOk"></lonlat-map>
    </a-modal>
    <!-- style="position: absolute; left: 18rem; z-index: 999; top: 3rem" -->
    <a-form-model
      class="log-form"
      :model="addOrUpdateForm"
      ref="addOrUpdateForm"
      :rules="rules"
      :label-col="{ span: 6 }"
      :wrapper-col="{ span: 18 }"
    >
      <a-row class="form-row" type="flex" justify="center" :gutter="4">
        <a-col :md="12" :sm="24" v-if="Reassign">
          <a-form-model-item label="工单编号" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
            <span v-if="!addOrUpdateForm.workNo">(系统自动生成)</span>
            <span v-else>{{ addOrUpdateForm.workNo }}</span>
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24" v-if="Reassign">
          <a-form-model-item v-if="Reassign" label="工单名称" prop="workName">
            <a-input v-model="addOrUpdateForm.workName"></a-input>
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item label="负责人" prop="principal">
            <a-select
              show-search
              option-filter-prop="children"
              :filter-option="filterOption"
              v-model="addOrUpdateForm.principal"
              @change="handleChange"
            >
              <a-select-option v-for="item in userlist" :key="item.id">{{ item.realName }}</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24" v-if="!Reassign"> </a-col>
        <a-col :md="12" :sm="24" v-if="Reassign">
          <a-form-model-item v-if="Reassign" label="维修泵房" prop="pumpId">
            <a-select v-model="addOrUpdateForm.pumpId" placeholder="选择一个泵房绑定">
              <a-select-option v-for="(item, index) in userlis" :key="index" :value="item.key">
                {{ item.title }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item label="其他维修人员">
            <a-button @click="addSponsor" style="margin-right: 20px">添加</a-button>
            <a-tag v-for="item in maintenancePersonsList" :key="item.key" closable @close="delSponsor(item.key)">{{
              item.title
            }}</a-tag>
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24"></a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item label="预期开始时间" prop="predictSme">
            <a-date-picker
              v-model="addOrUpdateForm.predictSme"
              format="YYYY-MM-DD"
              :disabled-date="disabledDate"
              :disabled-time="disabledDateTime"
              @change="onChanget"
              style="width: 100%;"
            />
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item label="预期处理时长" prop="planTime">
            <a-input placeholder="请输入" v-model="addOrUpdateForm.planTime" />
          </a-form-model-item>
        </a-col>
        <a-col :md="24" :sm="24">
          <a-form-model-item label="工单内容" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }" prop="deviceName">
            <a-textarea placeholder="多行输入" v-model="addOrUpdateForm.deviceName" :rows="2" />
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24" v-if="Reassign">
          <a-form-model-item label="是否需要停水事件" prop="isWaterOffEvent" :label-col="{ span: 10 }" :wrapper-col="{ span: 14 }">
            <a-radio-group v-model="addOrUpdateForm.isWaterOffEvent" @change="WaterOffEventchange">
              <a-radio :value="0">否</a-radio>
              <a-radio :value="1">是</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item
            label="是否关联停水事件"
            prop="isRelationWaterOffEvent"
            :label-col="{ span: 10 }"
            :wrapper-col="{ span: 14 }"
            v-if="WaterOf"
          >
            <a-radio-group v-model="addOrUpdateForm.isRelationWaterOffEvent" @change="WaterOffEvent">
              <a-radio :value="0">否</a-radio>
              <a-radio :value="1">是</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <div v-if="WaterOf">
          <a-col :md="24" :sm="24" v-if="rOffEven">
            <a-form-model-item
              label="关联停水事件"
              :label-col="{ span: 3 }"
              :wrapper-col="{ span: 20 }"
              prop="waterEventId"
            >
              <a-select
                show-search
                option-filter-prop="children"
                :filter-option="filterOption"
                v-model="addOrUpdateForm.waterEventId"
                @change="waterEventchange"
              >
                <a-select-option v-for="item in waterEven" :key="item.id">{{
                  item.eventName + item.eventNo
                }}</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :md="24" :sm="24">
            <a-form-model-item label="事件名称" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }" prop="eventName">
              <a-input placeholder="请输入" v-model="addOrUpdateForm.eventName" :disabled="this.rOffEven" />
            </a-form-model-item>
          </a-col>

          <a-col :md="12" :sm="24">
            <a-form-model-item label="爆管管段">
              <a-button type="primary" @click="openMap">选择爆管管段</a-button>
            </a-form-model-item>
          </a-col>
          <a-col :md="12" :sm="24">
            <a-form-model-item label="停水管理员" prop="waterAdminId">
              <a-select
                show-search
                :disabled="this.rOffEven"
                option-filter-prop="children"
                :filter-option="filterOption"
                v-model="addOrUpdateForm.waterAdminId"
              >
                <a-select-option v-for="item in userlist" :key="item.id">{{ item.realName }}</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :md="12" :sm="24">
            <a-form-model-item label="开始分类编码" prop="startClassNo">
              <a-input v-model="addOrUpdateForm.startClassNo" disabled />
            </a-form-model-item>
          </a-col>
          <a-col :md="12" :sm="24">
            <a-form-model-item label="结束分类编码" prop="endClassNo">
              <a-input v-model="addOrUpdateForm.endClassNo" disabled />
            </a-form-model-item>
          </a-col>
          <a-col :md="12" :sm="24">
            <a-form-model-item label="计划停水开始时间" prop="startValues" :label-col="{ span: 10 }" :wrapper-col="{ span: 14 }">
              <a-date-picker
                v-model="addOrUpdateForm.startValues"
                :disabled-date="disabledStartDates"
                @change="onChangehs"
                format="YYYY-MM-DD HH:mm:ss"
                @openChange="handleStartOpenChanges"
                :disabled="this.rOffEven"
                style="width: 100%;"
              />
            </a-form-model-item>
          </a-col>
          <a-col :md="12" :sm="24">
            <a-form-model-item label="计划停水结束时间" prop="endValues" :label-col="{ span: 10 }" :wrapper-col="{ span: 14 }">
              <a-date-picker
                v-model="addOrUpdateForm.endValues"
                :disabled-date="disabledEndDates"
                format="YYYY-MM-DD HH:mm:ss"
                :open="endOpens"
                @change="onChangets"
                @openChange="handleEndOpenChanges"
                :disabled="this.rOffEven"
                style="width: 100%;"
              />
            </a-form-model-item>
          </a-col>
          <a-col :md="24" :sm="24">
            <a-form-model-item label="事件描述" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }" prop="describe">
              <a-textarea
                placeholder="多行输入"
                :disabled="this.rOffEven"
                v-model="addOrUpdateForm.describe"
                :rows="3"
              />
            </a-form-model-item>
          </a-col>
        </div>
      </a-row>
    </a-form-model>
    <addModal ref="addModal" @addPepople="addPepople"></addModal>
    <a-modal class="log-form" :title="'选取位置'" width="50%" v-model="showMap" @ok="closeMap" @cancel="closeMap2">
      <input class="login-input" type="text" v-model="startLine" placeholder="请输入开始分类编码" />
      <input class="login-input" type="text" v-model="endLine" placeholder="请输入结束分类编码" />
      <a-button type="submit" @click="searchMapLine">查询</a-button>
      <mapTemplate ref="waterMap" v-on:childByValue="childByValue"></mapTemplate>
    </a-modal>
  </a-modal>
</template>
<script>
import dayjs from 'dayjs'
import moment from 'moment'
import addModal from './AddModal'
import LonlatMap from '../../../maintenance/EventManagement/modules/lonlatMap.vue'
import mapTemplate from '@/views/Water-outage-control/map-template.vue'
export default {
  components: {
    addModal,
    LonlatMap,
    dayjs,
    mapTemplate,
  },
  data() {
    return {
      mapVisible: false,
      WaterOf: false,
      dayjs,
      startLine: '',
      endLine: '',
      queryUrl: '/pipe-network/user_water_meters/page/geophysical-point-numbers',
      exportFileName: '影响用户数据.xlsx',
      exportDataUrl: 'pipe-network/user_water_meters/export',
      queryOneUrl: '/pipe-network/work_order_managements',
      showTubeView: false,
      showMap: false,
      id: '',
      addOrUpdateForm: {
        workNo: '',
        place: '',
        maintainAddress: '',
        startTime: '',
        endTime: '',
        deviceNo: '',
        deviceName: '',
        principal: '',
        deviceName: '',
        workName: '',
        pumpId: '',
        predictStime: '',
        predictSme: '',
        planTime: '',
        eventName: '',
        isRelationWaterOffEvent: 0,
        maintenancePersons: [],
        maintainPersons: [],
        startValues: '',
        endValues: '',
        isWaterOffEvent: '',
        waterAdminId: '',
        startClassNo: '',
        endClassNo: '',
        describe: '',
        lineId: '',
        eventNo: '',
      },
      zoneTreeData: [], // 分区数据选项
      eventTypeList: [],
      OrderTypeList: [], //工单类型
      userlist: [],
      waterEven: [],
      userlis: '',
      maintenancePersonsList: [],
      maintainPersonsList: [],
      selectButton: '',
      title: '新增',
      Reassign: true,
      rOffEven: false,
    }
  },
  computed: {
    rules() {
      return {
        pumpId: [{ required: true, message: '请选择泵房名称', trigger: 'change' }],
        deviceName: [{ required: true, message: '请输入工单内容', trigger: 'change' }],
        workName: [{ required: true, message: '请选择工单名称', trigger: 'change' }],
        principal: [{ required: true, message: '请选择负责人', trigger: 'change' }],
        predictSme: [{ required: true, message: '请选择预期开始时间', trigger: 'change' }],
        endTime: [{ required: true, message: '请选择结束时间', trigger: 'change' }],
        maintenancePersons: [{ type: 'array', required: true, message: '请选择维修人员', trigger: ['change', 'blur'] }],
        planTime: [
          { required: true, message: '请输入预期处理时长', trigger: 'change' },
          { pattern: /^(?:[1-9]\d?|[1234]\d{2}|500)$/, message: '请输入正整数', trigger: 'change' },
        ],
        eventName: [{ required: true, message: '请输入事件名称', trigger: 'change' }],
        startValues: [{ required: true, message: '请选择停水开始时间', trigger: 'change' }],
        endValues: [{ required: true, message: '请选择停水结束时间', trigger: 'change' }],
        waterEventId: [{ required: true, message: '请选择关联事件', trigger: 'change' }],
        describe: [{ required: true, message: '请输入事件描述', trigger: 'change' }],
        waterAdminId: [{ required: true, message: '请选择停水管理人', trigger: 'change' }],
        isWaterOffEvent: [{ required: true, message: '请选择是否需要停水事件', trigger: 'change' }],
        isRelationWaterOffEvent: [{ required: true, message: '请选择是否关联停水事件', trigger: 'change' }],
        startClassNo: [{ required: true, message: '请输入开始分类编码', trigger: 'change' }],
        endClassNo: [{ required: true, message: '请输入结束分类编码', trigger: 'change' }],
      }
    },
  },
  created() {
    this.getUserList()
    this.getOrderTypeList()
    this.getUserLi()
  },
  methods: {
    childByValue(childValue) {
      this.startLine = childValue[0].properties.start_class_no 
      this.endLine = childValue[0].properties.end_class_no
      this.addOrUpdateForm.lineId = childValue[0].id.substr(childValue[0].id.lastIndexOf('.') + 1, 20)
    },
    //停水
    WaterOffEvent(value) {
      if (value.target.value == 1) {
        this.$http.get('/pipe-network/gis_water_events/binding/list').then((res) => {
          this.waterEven = res.data
          console.log(this.waterEven)
        })
        this.rOffEven = true
      } else {
        this.rOffEven = false
        this.addOrUpdateForm.describe = ''
        this.addOrUpdateForm.eventName = ''
        this.addOrUpdateForm.waterAdminId = ''
        this.addOrUpdateForm.endClassNo = ''
        this.addOrUpdateForm.startClassNo = ''
        this.addOrUpdateForm.startValues = ''
        this.addOrUpdateForm.endValues = ''
        this.addOrUpdateForm.planStartTime = ''
        this.addOrUpdateForm.planEntTime = ''
        this.addOrUpdateForm.eventName = ''
        this.addOrUpdateForm.eventNo = ''
        this.addOrUpdateForm.waterEventId = ''
      }
    },
    waterEventchange(value) {
      console.log(value, 'diaia')
      this.$http.get(`/pipe-network/gis_water_events/${value}`).then((res) => {
        this.addOrUpdateForm.describe = res.data.describe
        this.addOrUpdateForm.eventName = res.data.eventName
        this.addOrUpdateForm.waterAdminId = res.data.waterAdminId
        this.addOrUpdateForm.endClassNo = res.data.endClassNo
        this.addOrUpdateForm.startClassNo = res.data.startClassNo
        this.addOrUpdateForm.startValues = res.data.planStartTime
        this.addOrUpdateForm.endValues = res.data.planEntTime
        this.addOrUpdateForm.planStartTime = res.data.planStartTime
        this.addOrUpdateForm.planEntTime = res.data.planEntTime
        this.addOrUpdateForm.eventNo = res.data.eventNo
        console.log(res.data.describe)
      })
    },
    openMap() {
      this.showMap = true
      this.$refs.waterMap.redSource.clear()
    },
    closeMap() {
      this.addOrUpdateForm.endClassNo = this.endLine
      this.addOrUpdateForm.startClassNo = this.startLine
      this.startLine = ''
      this.endLine = ''
      this.showMap = false
      this.$refs.waterMap.redSource.clear()
    },
    closeMap2() {
      this.showMap = false
      this.startLine = ''
      this.endLine = ''
      this.$refs.waterMap.redSource.clear()
    },
    searchMapLine() {
      this.$refs.waterMap.searchLines(this.startLine, this.endLine)
    },
    showmap() {
      this.mapVisible = true
    },
    disabledStartDates(current) {
      return current && current < dayjs().endOf('day')
    },
    disabledEndDates(endValue) {
      const startValue = this.addOrUpdateForm.startValues
      if (!endValue || !startValue) {
        return false
      }
      return startValue.valueOf() >= endValue.valueOf()
    },
    handleStartOpenChanges(open) {
      if (!open) {
        this.endOpens = true
      }
    },
    handleEndOpenChanges(open) {
      this.endOpens = open
    },
    onChangehs(date, dateString) {
      this.addOrUpdateForm.planStartTime = dateString
    },
    onChangets(date, dateString) {
      this.addOrUpdateForm.planEntTime = dateString
      console.log(this.addOrUpdateForm.planEntTime)
    },
    //停水
    WaterOffEventchange(value) {
      if (value.target.value == 1) {
        this.WaterOf = true
      } else {
        this.WaterOf = false
      }
    },
    disabledDate(current) {
      return current && current < dayjs().endOf('day')
    },
    disabledDateTime() {},
    onChanget(value, dateString) {
      this.addOrUpdateForm.predictStime = dateString + ' 00:00:00'
    },
    getUserLi() {
      this.$http.get('/pipe-network/twice_water_pumps/list').then(({ data }) => {
        
        let list = []
        data.map((item) => {
          console.log(item)
          list.push({
            title: item.pumpName + ' (' + item.pumpNo + ')',
            key: item.id,
          })
        })
        this.userlis = list
      })
    },
    handleMapOk(data) {
      this.addOrUpdateForm.maintainAddress = data.address
      this.addOrUpdateForm.place = data.point
      console.log(this.addOrUpdateForm.address)
    },
    moment,
    getOrderTypeList() {
      const params = {
        dictCode: 'WORK_ORDER_TYPE',
      }
      this.$http.get('/manager/dicts/children', { params }).then(({ data }) => {
        this.OrderTypeList = data
      })
    },
    addSupervisor() {
      console.log(this.maintainPersonsList)
      this.selectButton = 'Supervisor'
      this.$refs.addModal.edit(this.addOrUpdateForm.maintainPersons)
    },
    showLineLayer(record) {
      this.geoJson = record.geoJson
      this.mapVisible = true
    },
    addSponsor() {
      this.selectButton = 'Sponsor'
      this.$refs.addModal.edit(this.addOrUpdateForm.maintenancePersons)
    },
    addPepople(list) {
      if (this.selectButton == 'Sponsor') {
        this.maintenancePersonsList = list
        this.addOrUpdateForm.maintenancePersons = []

        list.length
          ? list.map((item) => {
              this.addOrUpdateForm.maintenancePersons.push(item.key)
            })
          : ''
      } else {
        this.maintainPersonsList = list
        this.addOrUpdateForm.maintainPersons = []
        list.length
          ? list.map((item) => {
              this.addOrUpdateForm.maintainPersons.push(item.key)
            })
          : ''
      }
    },
    delMaintain(key) {
      let i = this.maintainPersonsList.findIndex((item) => {
        return item.key == key
      })
      this.maintainPersonsList.splice(i, 1)
      let j = this.addOrUpdateForm.maintainPersons.indexOf(key)
      this.addOrUpdateForm.maintainPersons.splice(j, 1)
    },
    delSponsor(key) {
      let i = this.maintenancePersonsList.findIndex((item) => {
        return item.key == key
      })
      this.maintenancePersonsList.splice(i, 1)
      let j = this.addOrUpdateForm.maintenancePersons.indexOf(key)
      this.addOrUpdateForm.maintenancePersons.splice(j, 1)
    },
    handleChange(value) {
      this.addOrUpdateForm.principal = value
    },
    getUserList() {
      this.$http.get('/manager/users/list').then(({ data }) => {
        this.userlist = data
      })
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    beginOnChange(value, dateString) {
      this.addOrUpdateForm.startTime = dateString
    },
    endOnChange(value, dateString) {
      this.addOrUpdateForm.endTime = dateString
    },
    _updateForm(real, data) {
      let keys = Object.keys(real)
      let dataKeys = Object.keys(data)
      let newObject = {}
      keys.map((key) => {
        if (dataKeys.includes(key)) {
          newObject[key] = data[key]
        } else {
          newObject[key] = real[key]
        }
      })
      return newObject
    },
    ReassignHandle(id) {
      this.showTubeView = true
      this.Reassign = false
      this.currentId = id
      this.addOrUpdateForm = {
        workNo: '',
        place: '',
        maintainAddress: '',
        startTime: '',
        endTime: '',
        deviceNo: '',
        deviceName: '',
        principal: '',
        deviceName: '',
        workName: '',
        pumpId: '',
        predictStime: '',
        predictSme: '',
        planTime: '',
        eventName: '',
        eventNo: '',
        waterEventId: '',
        isRelationWaterOffEvent: '',
        maintenancePersons: [],
        maintainPersons: [],
      }
      this.$nextTick(() => {
        this.$refs.addOrUpdateForm.resetFields()
        if (id) {
          this.title = '转派人员'
          this.isUpdate = true
          this.$http
            .get(`${this.queryOneUrl}/${this.currentId}`)
            .then(({ data }) => {
              this.addOrUpdateForm.predictSme = data.predictStime
              this.addOrUpdateForm = { ...this._updateForm(this.addOrUpdateForm, data) }
              this.getPeopleList()
            })
            .catch(() => {})
        }
      })
    },
    edit(id) {
      this.showTubeView = true
      this.Reassign = true
      this.currentId = id
      this.addOrUpdateForm = {
        workNo: '',
        place: '',
        maintainAddress: '',
        startTime: '',
        endTime: '',
        deviceNo: '',
        deviceName: '',
        principal: '',
        deviceName: '',
        workName: '',
        pumpId: '',
        predictStime: '',
        planTime: '',
        eventName: '',
        isRelationWaterOffEvent: '',
        predictSme: '',
        maintenancePersons: [],
        maintainPersons: [],
        startValues: '',
        endValues: '',
        waterAdminId: '',
        waterEventId: '',
        isWaterOffEvent: '',
        waterEventId: '',
        startClassNo: '',
        endClassNo: '',
        describe: '',
        eventNo: '',
        waterEventId: '',
      }
      this.title = '新增'
      this.$nextTick(() => {
        this.$refs.addOrUpdateForm.resetFields()
        if (id) {
          this.title = '编辑'
          this.isUpdate = true
          this.$http
            .get(`${this.queryOneUrl}/${this.currentId}`)
            .then(({ data }) => {
              
              console.log(this._updateForm(this.addOrUpdateForm, data))
              this.addOrUpdateForm = { ...this._updateForm(this.addOrUpdateForm, data) }
              this.getPeopleList()
            })
            .catch(() => {})
        }
      })
    },
    getPeopleList() {
      this.$http.get('/manager/users/list').then(({ data }) => {
        
        let list = []
        data.map((item) => {
          list.push({
            title: item.realName,
            key: item.id,
          })
        })

        if (this.addOrUpdateForm.maintenancePersons.length) {
          this.maintenancePersonsList = []
          this.addOrUpdateForm.maintenancePersons.map((item) => {
            this.maintenancePersonsList.push(
              list.find((listItem) => {
                return listItem.key == item
              })
            )
          })
          console.log(this.maintenancePersonsList, '1234')
        }
        if (this.addOrUpdateForm.maintainPersons.length) {
          this.maintainPersonsList = []
          this.addOrUpdateForm.maintainPersons.map((item) => {
            this.maintainPersonsList.push(
              list.find((listItem) => {
                return listItem.key == item
              })
            )
          })
          console.log(this.maintainPersonsList, '1234')
        }
      })
    },
    //获取数据
    getDataList() {
      this.dataListLoading = true
      let params = {
        geophysicalPointNumber: this.id,
        // geophysicalPointNumber: 'JS581',
        page: this.pagination.current,
        limit: this.pagination.pageSize,
      }
      this.$http
        .get(this.queryUrl, {
          params,
        })
        .then(({ data }) => {
          
          this.dataListLoading = false
          this.dataList = data.list || []
          this.pagination.total = data.total ? parseInt(data.total) : 0
        })
        .catch(() => {
          this.dataListLoading = false
        })
    },
    handleOk(e) {
      e.preventDefault()
      this.$refs.addOrUpdateForm.validate((valid) => {
        if (valid) {
          this.$http[!this.currentId ? 'post' : 'put']('/pipe-network/work_order_managements', {
            id: this.currentId,
            sysType: '二次供水',
            ...this.addOrUpdateForm,
          })
            .then((res) => {
              if (res.code === 0) {
                this.closeTubeView()
                this.$emit('handleOk')
                this.addOrUpdateForm.describe = ''
                this.WaterOf = false
                return this.$message.success(res.message)
              }
            })
            .catch(() => {})
        }
      })
    },
    closeTubeView() {
      this.showTubeView = false
      this.WaterOf = false
      this.$refs.addOrUpdateForm.resetFields()
      this.maintenancePersonsList = []
      this.maintainPersonsList = []
      this.addOrUpdateForm.describe = ''
      this.$emit('handleOk')
    },
  },
}
</script>

<style lang="less" scoped>
</style>
